<span class="plus basket-add" tabindex="0" data-toggle="modal" data-target="#addBasket" title="Add current document to Basket. Then click on Basket icon at the top to pay and download.">&nbsp;&nbsp;Add to Basket</span>
<div class="modal fade" id="addBasket" tabindex="-1" role="dialog" aria-labelledby="addToBasket" aria-hidden="true">
  <div class="modal-dialog add-bskt" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addToBasket">Add to Download list...</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <button type="button" (click)="addToBasket(true)" data-dismiss="modal">Whole Document</button>
        <button type="button" (click)="addToBasket(false)" data-dismiss="modal">This Page</button>
      </div>
    </div>
  </div>
</div>
<dx-popup [width]="350"
          [height]="150"
          [showTitle]="true"
          title="Information"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisible">
  <div>
    <p>
      {{Message}}
    </p>

  </div>
</dx-popup>
<!--<span class="basket-count">{{basketItems.length}}</span>
<img tabindex="0" title="Shopping Basket" class="basket-img" src="images/basket.png" data-toggle="modal" data-target="#openBasket" (click)="getBasket()">-->
<!--<div class="modal fade" id="openBasket" tabindex="-1" role="dialog" aria-labelledby="basketItems">
  <div class="modal-dialog disp-bskt" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="basketItems">Download Options</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeBasket()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <dx-data-grid id="grid"
                      [dataSource]="basketItems"
                      [repaintChangesOnly]="true"
                      [showBorders]="true"
                      (onRowRemoving)="deleteRow($event)">

          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-editing mode="cell"
                       [refreshMode]="'full'"
                       [allowDeleting]="true">
          </dxo-editing>

          <dxi-column dataField="bookpage" caption="Document or Book/Page" [width]="120" [allowFiltering]="false"
                      [allowSorting]="false"></dxi-column>
          <dxi-column dataField="docType" caption="Type" [width]="50" [allowFiltering]="false"
                      [allowSorting]="false"></dxi-column>
          <dxi-column dataField="pageCount" caption="No.Pages" [width]="70" [allowFiltering]="false"
                      [allowSorting]="false"></dxi-column>
          <dxi-column caption="Download" [width]="60" [allowFiltering]="false"
                      [allowSorting]="false" cellTemplate="downloadTemplate"></dxi-column>
          <dxi-column caption="Download As" [width]="80" [allowFiltering]="false"
                      [allowSorting]="false" cellTemplate="downloadasTemplate"></dxi-column>
          <div *dxTemplate="let row of 'emailTemplate'">
            <input type="checkbox" [(ngModel)]="row.data.isEmail" />
          </div>
          <div *dxTemplate="let row of 'downloadTemplate'">
            <input type="checkbox" [(ngModel)]="row.data.isDownload" />
          </div>
          <div *dxTemplate="let row of 'downloadasTemplate'; let i=index">
            <input type="radio" value="pdf" name="radio{{row.data.bookpage}}" [(ngModel)]="row.data.downloadAs" />PDF
            <input type="radio" value="tif" name="radio{{row.data.bookpage}}" [(ngModel)]="row.data.downloadAs" />TIF
          </div>
          <div *dxTemplate="let row of 'includedetailTemplate'">
            <input type="checkbox" />
          </div>

        </dx-data-grid>

      </div>
      <div class="modal-msg">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*** TIF images are more efficient for large downloads (more than 50 pages)</div>
      <div class="modal-footer" *ngIf="machineType === 0">
        <label for="radioPaymentMethod" style="text-align: left;">Payment Method&nbsp;&nbsp;</label>
        <input type="radio" value="1" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Account&nbsp;&nbsp;
        <input type="radio" value="2" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Credit Card
        <button type="button" class="dwnld" (click)="buildSBList($event)" data-toggle="modal" data-target="#openBasket">Download Checked Items</button>
      </div>
      <div class="modal-footer" *ngIf="machineType === 1">
        <label for="radioPaymentMethod" style="text-align: left;">Payment&nbsp;&nbsp;</label>
        <input type="radio" value="1" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Account
        <input type="radio" value="2" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Credit Card
        <input type="radio" value="3" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Pay at Counter
        <button type="button" class="dwnld" (click)="buildSBList($event)" data-toggle="modal" data-target="#openBasket">Download Checked Items</button>
      </div>
      <div class="modal-footer" *ngIf="machineType === 2">
        <label for="radioPaymentMethod" style="text-align: left;">Print Method&nbsp;&nbsp;</label>
        <input type="radio" value="3" name="radioPaymentMethod" [(ngModel)]="paymentMethod" />Print at Counter
        <button type="button" class="dwnld" (click)="buildSBList($event)" data-toggle="modal" data-target="#openBasket">Download Checked Items</button>
      </div>

    </div>
  </div>
</div>-->

